import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.dark.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.dark.css';
import './themes/generated/theme.additional.css';
import { createApp }  from "vue";
import router from "./router";
import themes from "devextreme/ui/themes";

import App from "./App";
import appInfo from "./app-info";

import config from 'devextreme/core/config';
import { licenseKey } from '../devextreme-license';

import MyGrid from './components/my-grid.vue';
import myRemoteGrid from './components/my-remote-grid.vue';
import MyTitle from './components/my-title.vue';
import MySpacer from './components/my-spacer.vue';

import MyEditDialog from './components/my-edit-dialog.vue';
import MyForm from './components/my-form.vue';
import MyLoadPanel from './components/my-load-panel.vue';

import 'animate.css';
import MySpacerLg from './components/my-spacer-lg.vue';


import './tw.css';
import "./style.css";
import "./brand.css";
import "./localization-id";
import { createPinia } from 'pinia';
import { useAppStore } from './stores/app-store';
import { installUx } from './ux';

themes.initialized(() => {
    const app = createApp(App);
    app.config.globalProperties.$appInfo = appInfo;
    
    config({ licenseKey });
    
    app.use(createPinia());
    app.use(router);
    // Crash reporter (always on) + UX events (only when the tenant's ux_analytics flag is on).
    try {
        installUx(app, router, useAppStore());
    } catch (e) {
        console.error(e);
    }
    app.component('MyGrid', MyGrid);
    app.component('MyRemoteGrid', myRemoteGrid);
    app.component('MyLoadPanel', MyLoadPanel);
    app.component('MyTitle', MyTitle);
    app.component('MySpacer', MySpacer);
    app.component('MySpacerLg', MySpacerLg);
    app.component('MyEditDialog', MyEditDialog);
    app.component('MyForm', MyForm);
    app.mount('#app');
});
